import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
const { wp } = window;

/**
 * Media Upload component
 */
class MediaUpload extends PureComponent {
	/**
	 * Constructor
	 *
	 * @param {Object} props
	 */
	constructor( props ) {
		super( props );

		this.frame = null;
		this.open = this.open.bind( this );
	}

	/**
	 * Open the frame
	 */
	open() {
		if ( this.frame ) {
			this.frame.open();
		}
	}

	/**
	 * Once component is mounted, initialize the media frame
	 */
	componentDidMount() {
		// Create a new media frame
		this.frame = wp.media( {
			title: 'Select or Upload Media',
			button: {
				text: 'Select',
			},
			multiple: false, // Set to true to allow multiple files to be selected
		} );

		// When an image is selected in the media frame...
		this.frame.on( 'select', () => {
			// Get media attachment details from the frame state
			const attachment = this.frame
				.state()
				.get( 'selection' )
				.first()
				.toJSON();

			this.props.onSelect( attachment );
		} );
	}

	/**
	 * Render the media upload button
	 */
	render() {
		return (
			<Fragment>
				<button
					onClick={ this.open }
					className="components-button is-button is-default"
				>
					<i
						className="mce-ico mce-i-dashicon dashicons-admin-media"
						style={ {
							verticalAlign: 'middle',
							marginTop: '3px',
							marginRight: '10px',
						} }
					></i>
					{ this.props.buttonLabel }
				</button>
			</Fragment>
		);
	}
}

/**
 * Valid props
 */
MediaUpload.propTypes = {
	buttonLabel: PropTypes.string,
	onSelect: PropTypes.func,
};

// Default props
MediaUpload.defaultProps = {
	buttonLabel: 'Add Media',
	onSelect: () => {},
};

export default MediaUpload;
